import React from 'react';

const AttendanceShow = ({ attendance }) => {
  const { arrival, arrivalBreakTime, departureBreakTime, departure, name, nationalIdentification, date } = attendance;

  const translateField = field => {
    const translations = {
      arrival: 'Entrada',
      arrival_break_time: 'Entrada Colación',
      departure_break_time: 'Salida Colación',
      departure: 'Salida',
      active: 'Activo',
      disabled: 'Inactivo'
    };
    return translations[field] || field;
  };

  const renderChanges = versions => {
    return versions
      .map(version => {
        const { objectChanges } = version;

        if (!objectChanges) return '';
        const changes = [];
        if (version.event === 'create') {
          console.log(objectChanges);
          if (objectChanges.time && objectChanges.shifts) {
            changes.push(
              `Se creó una marcación: ${new Date(objectChanges.time[1]).toLocaleString('en-GB')} con el turno: ${
                objectChanges.shifts[1].name
              }, Correo enviado el ${new Date(version.createdAt).toLocaleString('en-GB')}`
            );
          }
          if (objectChanges.time && !objectChanges.shifts) {
            changes.push(
              `Se creó una marcación: ${new Date(objectChanges.time[1]).toLocaleString(
                'en-GB'
              )}, Correo enviado el ${new Date(version.createdAt).toLocaleString('en-GB')}`
            );
          }
        }
        if (version.event === 'update') {
          if (objectChanges.time) {
            changes.push(
              `Marcación corregida de ${new Date(objectChanges.time[0]).toLocaleString('en-GB')} a ${new Date(
                objectChanges.time[1]
              ).toLocaleString('en-GB')}, Correo enviado el ${new Date(version.createdAt).toLocaleString('en-GB')}`
            );
          }
          if (objectChanges.shifts) {
            changes.push(
              `Turno corregido de ${objectChanges.shifts[0].name} a ${
                objectChanges.shifts[1].name
              }, Correo enviado el ${new Date(version.createdAt).toLocaleString('en-GB')}`
            );
          }
          if (objectChanges.timeType) {
            changes.push(
              `Tipo de marcación corregido de ${translateField(objectChanges.timeType[0])} a ${translateField(
                objectChanges.timeType[1]
              )}, Correo enviado el ${new Date(version.createdAt).toLocaleString('en-GB')}`
            );
          }
          if (objectChanges.status) {
            changes.push(
              `Estado corregido de ${translateField(objectChanges.status[0])} a ${translateField(
                objectChanges.status[1]
              )}, Correo enviado el ${new Date(version.createdAt).toLocaleString('en-GB')}`
            );
          }
        }

        return changes.join('\n');
      })
      .join('\n');
  };

  const renderRow = (label, records) => (
    <tr>
      <td>{label}</td>
      <td style={{ whiteSpace: 'pre-line' }}>{records ? records.map(arr => arr.parsedTime).join('\n') : ''}</td>
      <td style={{ whiteSpace: 'pre-line' }}>
        {records ? records.map(arr => renderChanges(arr.versions)).join('\n') : ''}
      </td>
    </tr>
  );

  return (
    <div>
      <p>
        <strong>Nombre del Trabajador:</strong> {name}
      </p>
      <p>
        <strong>RUT del Trabajador:</strong> {nationalIdentification}
      </p>
      <p>
        <strong>Fecha:</strong> {date}
      </p>

      <table border="1" cellPadding="10" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Tipo de Marcación</th>
            <th>Fecha y Hora</th>
            <th>Modificaciones</th>
          </tr>
        </thead>
        <tbody>
          {renderRow('Entrada', arrival)}
          {renderRow('Entrada Colación', arrivalBreakTime)}
          {renderRow('Salida Colación', departureBreakTime)}
          {renderRow('Salida', departure)}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceShow;
